import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createAssetSubType } from '@api/assetTypes';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';
import { IAssetSubTypeDTO } from '@interfaces/platform/dto/manageAssetTypesDTO';

import { ESnackbarTypes } from '@enums/common';
import { EErrorCodes } from '@enums/errorCodes';

import { CREATE_ASSET_SUB_TYPE, MANAGE_ASSET_TYPES } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCreateAssetSubType = () => {
	const dispatch = useAppDispatch();

	const queryClient = useQueryClient();

	const {
		mutate: handleCreateAssetSubType,
		isLoading: isLoadingCreateAssetSubType,
	} = useMutation<IAssetSubTypeDTO>({
		mutationKey: [CREATE_ASSET_SUB_TYPE],
		mutationFn: createAssetSubType,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetSubTypeCreated,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([MANAGE_ASSET_TYPES])];
		},
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => item.code === EErrorCodes.assetSubTypeNameMustBeUnique)) {
				handleErrorFromMessage(err);
			}
		},
	});

	return {
		handleCreateAssetSubType,
		isLoadingCreateAssetSubType,
	};
};
